import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EmailInvoiceDialogService } from '../../dialogs/email-invoice/email-invoice.service.dialog';
import { EmailReceiptDialogService } from '../../dialogs/email-receipt/email-receipt.service.dialog';
import { RecordPaymentDialogService } from '../../dialogs/record-payment/record-payment.service.dialog';
import { RequestReviewServiceDialog } from '../../dialogs/request-review/request-review.service.dialog';
import { SendSMSServiceDialog } from '../../dialogs/send-sms/send-sms.service.dialog';
import { InvoiceInterface, InvoiceStatus } from '@contracts/interfaces/invoice.interface';
import { Job } from '@contracts/interfaces/job.interface';
import { ConnectionService } from '../../services/connection.service';
import { InvoicesService } from '../../services/invoices.service';
import { JobService } from '../../services/job.service';
import { PDFService } from '../../services/pdf.service';
import { TemplateService } from '../../services/template.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { I } from '@angular/cdk/keycodes';

export interface DialogData {
  invoice: InvoiceInterface,
  type: string
}

@Component({
  selector: 'app-invoice-dialog',
  templateUrl: 'invoice.dialog.html',
  styleUrls: ['./invoice.dialog.scss']
})
export class InvoiceDialogComponent {

  public isEditting = true;

  public hasPdf: boolean = false;
  public pdfHash: string;
  public pdfSrc: string;
  public htmlSrc: string;
  public pdfSrcView: string;
  public pdfSrcDownload: string;

  public type: string;
  public invoice: InvoiceInterface;

  public mode: string;

  @ViewChild('dialogContent') dialogContent: ElementRef;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<InvoiceDialogComponent>,
    private invoiceService: InvoicesService,
    private pdfService: PDFService,
    private jobService: JobService,
    private emailInvoiceDialogService: EmailInvoiceDialogService,
    private emailReceiptDialogService: EmailReceiptDialogService,
    private sendSMSDialogService: SendSMSServiceDialog,
    private connectionService: ConnectionService,
    private templateService: TemplateService,
    ) {

      if (data.invoice == undefined) {
        this.type = data.type;
        this.mode = 'create';
      } else {
        this.mode = 'edit';
        this.type = data.invoice.type;
        this.invoice = data.invoice;

        this.load(this.invoice.number);
      }
    }

  ngOnInit(): void {

  }

  next() {

  }

  previous() {
    
  }

  load(invoiceNumber: number) {
    if (!invoiceNumber) {
      return;
    }

    this.invoiceService.get(invoiceNumber).subscribe((r:any)=> {
      this.invoice = this.invoiceService.validate(r);
      console.log(this.invoice)
      // if (this.invoice.number == 3201) {
      //   this.invoice.isGSTIncluded = false;
      //   this.invoiceService.updateOne(this.invoice);
      //   console.log("DONE");
      // }
      this.pdfService.check(this.invoice.pdf.file, this.invoice).subscribe((result: any) => {

        if (result.hash == null) {
          this.generatePDF(this.invoice);
        } else {  
          this.hasPdf = true;
          this.pdfHash = result.hash;
          this.pdfSrc = this.connectionService.address + "/pdf-service/view?file="+result.hash+"&i=" + Date.now();

          this.htmlSrc = this.connectionService.address + "/templates/pdfs/" + result.hash + "/index.html";
          this.pdfSrcView = this.connectionService.address + "/pdf-service/view?file="+result.hash + "&i=" + Date.now();
          this.pdfSrcDownload = this.connectionService.address + "/pdf-service/view?file="+result.hash+"&filename=invoice-" + this.invoice.number + "&i=" + Date.now()
        }
      })
    })
  }

  editInvoice() {
    this.isEditting = true;
    this.dialogContent.nativeElement.scrollTop = 0
  }

  reloadPDF() {
    this.generatePDF(this.invoice);
    this.isEditting = false;
  }

  previewInvoice() {
    this.isEditting = false;
    this.dialogContent.nativeElement.scrollTop = 0
  }

  duplicateInvoice() {
    // this.invoiceService.getAvailableInvoiceNumber().subscribe((result: any) => {
    //   let newInvoice: InvoiceInterface = JSON.parse(JSON.stringify(this.invoice));
    //   newInvoice.number = result.number;
    //   delete newInvoice["_id"];
    //   this.invoiceService.create(newInvoice).subscribe((r: any) => {
    //     this.router.navigate(["view-invoice", newInvoice.number]);
    //   });
    // })
  }

  deleteInvoice() {
    if (!this.invoice?.number) {
      return;
    }

    this.invoiceService.deleteOne(this.invoice).subscribe(r=> {
      this.dialogRef.close();
    })
  }

  generatePDF (invoice: InvoiceInterface) {
    this.pdfSrc = null;

    this.pdfService.generatePDF2(invoice.pdf.file, invoice).subscribe((result: any) => {
      this.pdfHash = result.hash;
      this.pdfSrc = this.connectionService.address + "/pdf-service/view?file="+result.hash+"&i=" + Date.now();      
      this.htmlSrc = this.connectionService.address + "/templates/pdfs/" + result.hash + "/index.html";
      this.pdfSrcView = this.connectionService.address + "/pdf-service/view?file="+result.hash + "&i=" + Date.now();
      this.pdfSrcDownload = this.connectionService.address + "/pdf-service/view?file="+result.hash+"&filename=invoice-" + this.invoice.number + "&i=" + Date.now()

      this.hasPdf = true;
    })
  }

  addReminders() {
    console.clear()

    let date = new Date(this.invoice.dateDue);

    date.setDate(date.getDate() - 3);

    this.jobService.create({
      job: Job.INVOICE_REMINDER,
      date: {
        start: new Date()
      },
      data: {
        invoice: this.invoice.number
      }
    })
  }

  openPaymentDialog(refund: boolean = false) {
    let before = this.invoice.paymentsMade.length;

    this.invoiceService.openRecordPaymentDialog(this.invoice, refund, () => {
      this.load(this.invoice.number);
            
      // if (before != this.invoice.paymentsMade.length) {
      //   this.openEmailReceiptDialog()
      // }
    });
  }

  deletePayment(index: number) {
    this.invoice.paymentsMade.splice(index, 1);

    this.invoiceService.updateOne(this.invoice).subscribe(r => {
      this.load(this.invoice.number);
    })
  }

  openEmailInvoiceDialog() {
    this.emailInvoiceDialogService.open(this.invoice, this.pdfHash, (job: any) => {
      if (job != null) {
        this.invoice.communicationLog.push(job);

        this.invoiceService.updateOne(this.invoice).subscribe(r=>{});
      }
    });
  }

  openEmailReceiptDialog() {
    this.emailReceiptDialogService.open(this.invoice, (job: any) => {
      if (job != null) {
        this.invoice.communicationLog.push(job);

        this.invoiceService.updateOne(this.invoice).subscribe(r=>{});
      }
    });
  }

  smsInvoice() {

    let template = "sms-review-request.template.html"
    if (this.invoice.type == "ewaste") {
      template = "sms-review-request-ewaste.template.html";
    }

    this.templateService.renderFile(template, this.invoice).subscribe((template: any) => {
      this.sendSMSDialogService.open(this.invoice.customer, template.render, () => {

      });
    });
  }

  smsReview() {

    // this.requestReviewServiceDialog.open(this.invoice.customer, (r) => {

    // });

    // this.templateService.render("sms-review-request.template.html", this.invoice).subscribe((template: any) => {
    //   this.sendSMSDialogService.open(this.invoice.customer, template.render, (job: any) => {
    //     this.invoice.communicationLog.push(job);
    //     this.invoiceService.updateOne(this.invoice).subscribe(r=>{});
    //   });
    // });
  }

  approveDraft() {
    this.invoice = this.invoiceService.validate(this.invoice);
    
    if (this.invoice.amountDue > 0) {
      this.invoice.status = InvoiceStatus.Unpaid;
      this.invoiceService.updateOne(this.invoice).subscribe(r=> {});
    }
  }

  check () {
    console.log(this.invoice)
  }

  downloadPDF() {
    let filename = "invoice-" + this.invoice.number;

    this.pdfService.download(this.invoice.pdf.file, this.invoice, filename);
  }

  viewPDF() {
    this.pdfService.view(this.invoice.pdf.file, this.invoice);
  }

  printPDF() {
    this.pdfService.print(this.invoice.pdf.file, this.invoice);
  }

  invoiceSaved(invoice) {
    this.invoice = invoice;
    console.log(invoice)
    this.generatePDF(invoice);
    this.mode = 'edit';
    this.previewInvoice();
  }
}
